<div class="grid p-fluid">
  <div class="col-12 p-0 md:p-1 lg:px-8">
    <div class="card">
		<div class="grid">
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl" *ngIf="stepNo === 100">
				<p-tag icon="pi cm-alert" [value]="('INVALID_PERMISSION' | translate)" severity="warning" styleClass="text-lg"></p-tag>
				<p-tag icon="pi cm-alert" [value]="('INVALID_PERMISSION_REASON' | translate)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl" *ngIf="stepNo === 1">
				<p-tag icon="pi cm-alert" [value]="('PLEASE_SET_PIN' | translate)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl" *ngIf="stepNo === 2">
				<p-tag icon="pi cm-alert" [value]="('PLEASE_SET_PIN_AGAIN' | translate)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl" *ngIf="stepNo === 3">
				<p-tag icon="pi cm-alert" [value]="('PIN_SET_SUCCESS' | translate)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl" *ngIf="repeatError">
				<p-tag icon="pi cm-alert" [value]="('REPEAT_PIN_ERROR' | translate)" severity="warning" styleClass="text-lg"></p-tag>
					<p-button pTooltip="{{ 'RESET' | translate }}" class=""
          tooltipPosition="bottom" icon="pi cm-pencil" size="large"
          (click)="reset()" [rounded]="false" [text]="true" severity="secondary">
          </p-button>
			</div>
    </div>
    </div>
  </div>
</div>
